module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chap-title1",
    attrs: {
      "id": "C2"
    }
  }, [_vm._v("Materials")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("This section gives us the opportunity to introduce you to the most important material of all for any macraweave artist, the cords for tying the knots and weaving the negative spaces, as well as a few basic tools that you will need. The exact materials used for each design are listed at the beginning of each project chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("For the macramé structure in the projects we have used either thick cotton rope or hemp. When choosing your cotton rope, note that we have used a very soft 3-ply twisted cotton, although this can be substituted for cotton string. For the weaving element we have used a number of different fibre types, from soft yarns such as tapestry wool and cotton thread, to more textured materials including hemp, jute and sisal.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The length and thickness of the cords required for each design is given in the materials list at the start of each project. We suggest that you use the exact materials as we have for the macramé structure, but when you are confident with the macraweave technique, do explore making substitutions for our choices for the weaving element. Cord is available through the authors' website "), _c('a', {
    attrs: {
      "href": "http://www.edeneve.com.au",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("www.edeneve.com.au")])]), _vm._v(" or from all good suppliers and haberdashery stores.")]), _vm._v(" "), _c('h2', {
    staticClass: "subhead1"
  }, [_vm._v("Tools")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The basic tools you will need are scissors and a tape measure. Some of the projects do require the use of a hot glue gun and if so, this is noted in the materials list at the beginning of the project chapter. Unlike traditional loom weaving, the weaving element in our macraweave projects rarely requires tools. We have hand woven almost all of the projects, however some of the smaller more intricate projects, such as the key ring, benefit from the use of a yarn or tapestry needle. This type of needle has a rounded tip, with a large eye for threading thicker threads through. It is also helpful for weaving in the cord ends for a neat finish.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P10-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-text1"
  }, [_c('b', [_vm._v("Note:")]), _vm._v(" When buying and cutting rope and cord, use either the metric or the imperial measurements given – do not switch between the two.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P11-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b868a7d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter2.vue
// module id = 75
// module chunks = 0